var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))]),_c('div',{staticClass:"page-actions-wrapper"},[_vm._t("actions")],2)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }